// input 相关组件的断点宽度
export const INPUT_WIDTH = {
    'x-small': '104px',
    small: '216px',
    middle: '328px',
    large: '440px',
    'x-large': '552px',
};
// 设置当前表单宽度
export function setFormWidth(props, style = {}) {
    const propWidth = props.width;
    if (propWidth && typeof propWidth === 'string') {
        const width = INPUT_WIDTH[propWidth];
        width && (style.width = width);
    }
    return style;
}
